var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M20.448,20.452L16.893,20.452L16.893,14.883C16.893,13.555 16.866,11.846 15.041,11.846C13.188,11.846 12.905,13.291 12.905,14.785L12.905,20.452L9.351,20.452L9.351,9L12.765,9L12.765,10.561L12.811,10.561C13.288,9.661 14.448,8.711 16.181,8.711C19.782,8.711 20.448,11.081 20.448,14.166L20.448,20.452ZM5.337,7.433C4.193,7.433 3.274,6.507 3.274,5.368C3.274,4.23 4.194,3.305 5.337,3.305C6.477,3.305 7.401,4.23 7.401,5.368C7.401,6.507 6.476,7.433 5.337,7.433ZM7.119,20.452L3.555,20.452L3.555,9L7.119,9L7.119,20.452ZM22.225,0L1.771,0C0.792,0 0,0.774 0,1.729L0,22.271C0,23.227 0.792,24 1.771,24L22.222,24C23.2,24 24,23.227 24,22.271L24,1.729C24,0.774 23.2,0 22.222,0L22.225,0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.71fe2dd6.svg";
export { ForwardRef as ReactComponent };